module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Kunder",
      "identifier": "customers"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Kunder</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Ét samlet overblik over dine kunder\n            ")])]), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a790bfd4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a790bfd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/customers/customers.vue
// module id = 876
// module chunks = 0